<template>
    <div class="animated fadeIn scroll" :style="divstyle">
        <b-modal size="xl" title="Visualizzazione conoscenze e argomenti" class="modal-info" v-model="showcon" ok-only>
            <div v-html="htmlcon" />
        </b-modal>
        <b-modal size="lg" title="Attenzione" class="modal-info" v-model="forzaDoc" @ok="docOK = true, forzaDoc = false, savemod()">
            Non sei il docente assegnato a quest'ora: vuoi forzare l'inserimento ?
        </b-modal>
        <b-modal size="lg" title="Inserimento modulo e argomento" class="modal-info" v-model="insmod" @ok="savemod" :ok-only="false" :ok-disabled="insargokdis" ok-title="Salva"
            cancel-title="Mostra conoscenze" cancel-variant="info" @cancel="opencon">
            <div>
                Modulo:
                <multiselect id="modulilist" v-model="currmod" :options="availmods" :multiple="false" :searchable="false" :allow-empty="false" :deselectLabel="''" :close-on-select="true"
                    :disabled="!canchangemod || !docOK" label="nome" track-by="moduloid" @input="favmodsel"></multiselect>
            </div>
            <div>
                <br>
                Conoscenza:
                <multiselect id="conoscenzelist" v-model="currcon" :options="availcons" :multiple="false" :searchable="false" :allow-empty="false" :deselectLabel="''" :disabled="!docOK"
                    :close-on-select="true" label="conoscenze" track-by="mmpid" @input="favconsel"></multiselect>
                <br>
            </div>
            Argomento:
			<template v-if="!ECFOP">
            	<textarea class="argomento" rows=8 v-model="argomento" :disabled="insmodRO"></textarea>
			</template>
			<template v-else>
                <multiselect id="argomentilist" v-model="currarg" :options="availargs" :multiple="false" :searchable="false" :allow-empty="false" :deselectLabel="''" :disabled="!docOK"
                    :close-on-select="true" label="text" track-by="argid" @input="favargsel"></multiselect>
			</template>
        </b-modal>
        <b-modal size="lg" title="Inserimento/Visualizzazione note" class="modal-info" v-model="insnote" @ok="addnota2" :ok-disabled="tuttochiuso || !insdata || insnota == ''" :ok-only="false">
            <b-table-simple :bordered="false" :borderless="false" :outlined="true" :headVariant="'light'">
                <b-thead>
                    <b-tr>
                        <b-th>Data</b-th>
                        <b-th>Nota</b-th>
                        <b-th>Docente</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="nota in gnote" :key="nota.id">
                        <b-td>{{ nota.data | luxon }}</b-td>
                        <b-td>{{ nota.nota }}</b-td>
                        <b-td>{{ nota.nome }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>
                            <datetime class="datavoto2" v-model="insdata" :max-datetime="adesso" :min-datetime="mindata" />
                        </b-td>
                        <b-td>
                            <input v-model="insnota" />
                        </b-td>
                        <b-td></b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-modal>
        <b-modal title="Errore durante il salvataggio" class="modal-danger" v-model="errShow" @ok="errShow = false" ok-variant="danger" :ok-only="true">
            {{ errMessage }}
            <!-- div slot="modal-cancel">CANCEL</div -->
        </b-modal>
        <b-modal title="Inserimento modalità di verifica" class="modal-info" v-model="mvdescrShow" @ok="note2()" ok-variant="info" :ok-only="false">
            <input type="text" ref="mvdescrShow" :value="dmvdescr" class="w100" />
            <!-- div slot="modal-cancel">CANCEL</div -->
        </b-modal>
        <b-modal title="Inserimento media forzata" class="modal-warning" v-model="dforzamedia" @ok="forzamedia2()" ok-variant="info" :ok-only="false">
            <input type="number" ref="dforzamedia" />
            <!-- div slot="modal-cancel">CANCEL</div -->
        </b-modal>
        <b-modal title="Eliminare la forzatura ?" class="modal-danger" v-model="dforzamediadel" @ok="forzamediadel()" ok-variant="danger" :ok-only="false">
            Eliminare la media inserita manualmente ?
            <!-- div slot="modal-cancel">CANCEL</div -->
        </b-modal>
        <b-modal title="Eliminare il voto ?" class="modal-danger" v-model="delimina" @ok="elimina2()" ok-variant="danger" :ok-only="false">
            Eliminare il voto ?
        </b-modal>
        <InsVoto v-model="dwhatv" :show="daddvoto" :skills="progsel && !progsel.noss" />
        <div v-if="loading">
            <semipolar-spinner :animation-duration="2000" :size="65" color="#ff1d5e" />Loading...
        </div>
        <div v-if="!loading">
            <h1>
                Registro di valutazione {{ loctime.toFormat('dd/MM/yyyy') }}
                <span v-if="noprogsel">{{ progsel.nome }}</span>
            </h1>
            <h2>
                <span :class="seenclass(0)" @click="addnota(0)" v-if="progsel.progettoid > 0">
                    <i class="fa fa-paperclip"></i>
                </span>
            </h2>
            <span v-if="!noprogsel">
                <hr />Progetto:
                <multiselect id="progettilist" v-model="progsel" :options="progetti" :multiple="false" :close-on-select="true" label="nome" track-by="progettoid" :disabled="noprogsel"
                    @input="fprogsel"></multiselect>
            </span>
            <br />
            <div v-if="progsel.progettoid > 0">
                {{ ENAC ? 'Competenze:' : 'Moduli:' }}
                <button class="btn btn-info" @click="selall" v-if="getUserLIV() >= 1">{{ ENAC ? 'Tutte' : 'Tutti' }}</button>
                &nbsp;
                <button class="btn btn-info" @click="selpers(false)">Personali</button>
                <template v-if="ENAC">
                    &nbsp;
                    <button class="btn btn-info" @click="selpers(true)">Personali + Generali</button>
                </template>
                <multiselect id="modulilist" v-model="modsel" :options="moduli" :multiple="true" :close-on-select="true" label="nome" track-by="moduloid" @input="ifmodsel"></multiselect>
            </div>
            <hr />Medie:
            <toggle-button :value="showmedie" :sync="true" color="#82C7EB" :labels="true" @change="showmedieev" />
            <b-alert :show="dismissCountDown2" dismissible @dismissed="dismissCountDown2 = 0" @dismissCountDown="countDownChanged2" variant="danger">
                Non sei il docente previsto per quest'ora
            </b-alert>
            <!-- prospetto moduli della giornata -->
            <table class="prospettomoduli" v-if="cals && cals.length && !tuttochiuso" border=1>
                <tr>
                    <th v-for="c of cals" :key="c.ora">
						<!-- Posso sempre editare, poi verifico meglio nella funzione -->
                        <template v-if="!tuttochiuso">
                            <button class="btn btn-info" @click="setmod(c)">
                                {{ c.ora }} - {{ c.nome }}
                            </button>
                        </template>
                        <template v-else>
                            <span @click="viewmod(c)" :class="liv7">{{ c.ora }} - {{ c.nome }}</span>
                        </template>
                    </th>
                </tr>
            </table>

            <table class="registro">
                <tr>
                    <th>
                        Corsisti
                    </th>
                    <th v-for="modulo in fmodsel" :key="modulo.moduloid" class="rot90">
                        {{ modulo.nome }}
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="!soloquestomoduloid" class="clickme" @click="soloquestomoduloid = modulo.moduloid" title="Mostra solo questa colonna">
                            <i class="fa fa-eye"></i>
                        </span>
                        <span v-if="soloquestomoduloid" class="clickme" @click="soloquestomoduloid = false" title="Mostra tutte le colonne">
                            <i class="fa fa-eye-slash"></i>
                        </span>
                        <br />
                        <span>{{ modulo.doc }}</span>
                    </th>
                </tr>
                <tr v-for="alunno in falunni" :key="alunno.alunnoid">
                    <td class="nowrap">
                        {{ alunno.posizione }})
                        {{ alunno.cognome }}
                        {{ alunno.nome }}
                        <span :class="seenclass(alunno.alunnoid)" @click="addnota(alunno.alunnoid)">
                            <i class="fa fa-paperclip"></i>
                        </span>
                        &nbsp;&nbsp;&nbsp;
                        <span v-if="!soloquestoalunnoid" class="clickme" @click="soloquestoalunnoid = alunno.alunnoid" title="Mostra solo questo corsista">
                            <i class="fa fa-eye"></i>
                        </span>
                        <span v-if="soloquestoalunnoid" class="clickme" @click="soloquestoalunnoid = false" title="Mostra tutti i corsisti">
                            <i class="fa fa-eye-slash"></i>
                        </span>
                        <br>
                        <template v-if="!tuttochiuso">
							<span :class="'giustifica' + (giustifiche.includes(alunno.alunnoid) ? 'SI' : 'NO')"> - Giustifica:
								<select :value="giustifiche.includes(alunno.alunnoid) ? 'SI' : 'NO'"  @change="giustifica(alunno.alunnoid, $event)">
									<option value="NO">No</option>
									<option value="SI">Si</option>
								</select>
							</span>
							<span v-if="giustifiche.includes(alunno.alunnoid)">
								<select :value="giustifichedett[alunno.alunnoid].entra"  @change="giustificadett1(alunno.alunnoid, $event)">
									<option value="1">Entra</option>
									<option value="0">Esce</option>
								</select>
								<select v-if="giustifichedett[alunno.alunnoid].entra==0" :value="giustifichedett[alunno.alunnoid].ora"  @change="giustificadett2(alunno.alunnoid, $event)">
									<option value="9">9</option>
									<option value="10">10</option>
									<option value="11">11</option>
									<option value="12">12</option>
									<option value="13">13</option>
									<option value="14">14</option>
									<option value="15">15</option>
									<option value="16">16</option>
									<option value="17">17</option>
									<option value="18">18</option>
								</select>
							</span>
							<br>
                            Ingr: {{ alunno.ingresso }}
                            <br>
                            <div v-for="(value, ora) in pres['c' + alunno.corsistaid]" :key="ora">
                                <template v-if="oracorrente >= ora">
                                    {{ ora }} 
									<span :class="'presente' + gval(value)"> - Presente:
                                        <select :disabled="oracorrente > ora && false" :value="gval(value)" @change="sval('c' + alunno.corsistaid, ora, $event)">
                                            <option value="NO">No</option>
                                            <option value="SI">Si</option>
                                            <option value="NI">1/2</option>
                                        </select>
                                    </span>
                                </template>
                            </div>
							<span v-if="saving[alunno.alunnoid]===true" class="saving">Saving...</span>
							<span v-if="saving[alunno.alunnoid]===false" class="saved">Saved</span>
                        </template>
                        <div class="medie" v-if="showmedie">
                            <span style="padding-left:10px;">
                                <peity v-if="progsel && !progsel.noss" :type="'bar'" :options="baropts(alunno.alunnoid, 'media', 2)" :data="bardata(alunno.alunnoid, 'media', 2).toString()"
                                    :key="`${alunno.alunnoid}`"></peity>
                            </span>
                            <div :style="barmedia(alunno.alunnoid, 0)"></div>
                        </div>
                    </td>
                    <td v-for="modulo in fmodsel" :key="modulo.moduloid + '.' + alunno.alunnoid" class="nowrap">
                        <div v-if="modulo.moduloid == 999999 && modfad">
                            <div v-for="(ind) in fadindicatori" :key="ind">
                                {{ ind }}
                                <b-form-select v-model="voti['A' + alunno.alunnoid]['M' + modulo.moduloid][ind]" @change="savefad($event, alunno.alunnoid, ind)" :plain="true" :options="selOpts(ind)">
                                </b-form-select>
                            </div>
                        </div>
                        <div v-for="(voto, i) in voti['A' + alunno.alunnoid]['M' + modulo.moduloid]" :key="'A' + alunno.alunnoid + 'M' + modulo.moduloid + 'I' + i">
                            <input type="text" class="voto" :value="voto.voto" :style="stilevoto(voto.voto, modulo.moduloid)" v-if="modulo.moduloid < 0" :disabled="chiuso2(voto)"
                                :ref="'A' + alunno.alunnoid + 'M' + modulo.moduloid + 'PW'" />
                            <button @click="salvaneg(alunno.alunnoid, modulo.moduloid)" v-if="modulo.moduloid < 0 && !chiuso2(voto)">
                                <i class="fa fa-check"></i>
                            </button>
                            <template v-if="modulo.moduloid <= -2 && modulo.moduloid >= -4">
                                ({{ votouf(alunno.alunnoid, -1 - modulo.moduloid) }})
                            </template>
                            <template v-if="modulo.moduloid <= -8 && modulo.moduloid >= -10">
                                ({{ votouf(alunno.alunnoid, -4 - modulo.moduloid) }})
                            </template>
                            <div class="voto" v-if="voto.docenteid > 0 && modulo.moduloid >= 0" :style="stilevoto(voto.voto, modulo.moduloid)" :title="voto.nome" @click="showvoto(voto)">{{ voto.voto }}</div>
                            <div class="datavoto" v-if="voto.docenteid > 0 && modulo.moduloid >= 0" :title="voto.nome" @click="showvoto(voto)">{{ voto.data | itadata }}</div>
                            <button @click="elimina(voto.hm, voto.alunnoid, voto.moduloid, voto.data, i)" v-if="voto.docenteid > 0 && modulo.moduloid >= 0 && !chiuso(voto)">
                                <i class="fa fa-trash"></i>
                            </button>
                            <button @click="note(voto.hm, voto.alunnoid, voto.moduloid, voto.data)" v-if="voto.docenteid > 0 && modulo.moduloid >= 0 && !chiuso(voto)" :title="voto.descr"
                                :ref="alunno.alunnoid + '_' + voto.data + '_VD' + voto.hm">
                                <i class="fa fa-paperclip"></i>
                            </button>
                            <span v-if="voto.hm && !chiuso(voto)" class="votohm">
                                <i class="fa fa-home"></i>
                            </span>
                            <span v-if="voto.hm && chiuso(voto)" class="votohmc">
                                <i class="fa fa-home"></i>
                            </span>
                            <br />
                        </div>
                        <div class="premedie" v-show="showmedie && modulo.moduloid != 999999">
                            <button @click="addvoto(alunno.alunnoid, modulo.moduloid)" v-if="(modulo.moduloid > 10 || alunno.posizione == 'APPR' && modulo.moduloid >= 0) && caninsert" title="Aggiungi voto">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                        <div class="premedie2" v-show="!showmedie && modulo.moduloid != 999999">
                            <button @click="addvoto(alunno.alunnoid, modulo.moduloid)" v-if="(modulo.moduloid > 10 || alunno.posizione == 'APPR' && modulo.moduloid >= 0) && caninsert" title="Aggiungi voto">
                                <i class="fa fa-plus"></i>
                            </button>
                        </div>
                        <div class="medie" v-if="(modulo.moduloid > 10 || alunno.posizione == 'APPR' && modulo.moduloid >= 0) && showmedie && modulo.moduloid != 999999">
                            <hr />
                            <peity v-if="progsel && !progsel.noss" :type="'bar'" :options="baropts(alunno.alunnoid, modulo.moduloid, 1)" :data="bardata(alunno.alunnoid, modulo.moduloid, 1).toString()"
                                :key="`${alunno.alunnoid},${modulo.moduloid},1`"></peity>
                            &nbsp;
                            <peity v-if="progsel && !progsel.noss" :type="'bar'" :options="baropts(alunno.alunnoid, modulo.moduloid, 2)" :data="bardata(alunno.alunnoid, modulo.moduloid, 2).toString()"
                                :key="`${alunno.alunnoid},${modulo.moduloid},2`"></peity>
                            <div :style="barmedia(alunno.alunnoid, modulo.moduloid)"></div>
                            <br />
                            <div :class="medieclass(true)" :ref="alunno.alunnoid + '_' + modulo.moduloid + '_MV1'" @click="canforcemedia(true) && forzamedia(alunno.alunnoid, modulo.moduloid, 1)"
                                :title="mediatitle(alunno.alunnoid, modulo.moduloid, 1)">{{ media(alunno.alunnoid, modulo.moduloid, 1) }}</div>
                            <div :class="medievotoclass(true) + ' ' + forzamediaclass(alunno.alunnoid, modulo.moduloid, 1)" :ref="alunno.alunnoid + '_' + modulo.moduloid + '_MD1'"
                                @click="canforcemedia(true) && forzamedia(alunno.alunnoid, modulo.moduloid, 1)" :title="mediatitle(alunno.alunnoid, modulo.moduloid, 1)">
                                {{ mediadata(alunno.alunnoid, modulo.moduloid, 1) | itadata }}&nbsp;</div><span>&nbsp;{{ mediaciclo1 }}</span>
                            <br v-if="secsem" />
                            <div v-if="secsem" :class="medieclass(false)" :ref="alunno.alunnoid + '_' + modulo.moduloid + '_MV2'"
                                @click="canforcemedia(false) && forzamedia(alunno.alunnoid, modulo.moduloid, 2)" :title="mediatitle(alunno.alunnoid, modulo.moduloid, 2)">
                                {{ media(alunno.alunnoid, modulo.moduloid, 2) }}</div>
                            <div v-if="secsem" :class="medievotoclass(false) + ' ' + forzamediaclass(alunno.alunnoid, modulo.moduloid, 2)" :ref="alunno.alunnoid + '_' + modulo.moduloid + '_MD2'"
                                @click="canforcemedia(false) && forzamedia(alunno.alunnoid, modulo.moduloid, 2)" :title="mediatitle(alunno.alunnoid, modulo.moduloid, 2)">
                                {{ mediadata(alunno.alunnoid, modulo.moduloid, 2) | itadata }}&nbsp;</div><span v-if="secsem">&nbsp;{{ mediaciclo2 }}</span>
                        </div>
                    </td>
                </tr>
            </table>
            <b-alert :show="dismissCountDown" dismissible @dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged" variant="success">
                Presenze salvate
            </b-alert>
            <hr />
        </div>
    </div>
</template>
<script>
import { API } from "@/api.js";
import { SemipolarSpinner } from "epic-spinners";
import { DateTime } from "luxon";
import InsVoto from "./widgets/InsVoto";
import Peity from "vue-peity";
import { ToggleButton } from "vue-js-toggle-button";

/*
	COLONNE:
	 -1 - Project Work
	 -2 - UF1
	 -3 - UF2
	 -4 - UF3
	 -5 - Condotta
	 -6 - Stage
	 -7 - IRC
	 -8 - UF4
	 -9 - UF5
	 -10 - UF6
	 999999 - Mod. Rel.
	 0-2 - Apprendistato
*/

const NOSOFTSKILLS = true

export default {
  name: "dashboard",
  mixins: [window.myMixin],
  components: {
    SemipolarSpinner,
    InsVoto,
    Peity,
    ToggleButton
  },
  data: function() {
    return {
        ora: 0,
		oraToSave: null,
		tuttochiuso: false, // se ho fatto il secondo scruitinio chiudo tutto a prescindere
		dataChiuso: '2000-01-01', // i progetti con datascrutinio possono modificarla
		dataChiuso2: '2000-01-01', // i progetti con datascrutinio2 possono modificarla
		fad:[],
		fadscores: [],
		fadindicatori: [],
		insdata: "",
		insnota: "",
		notaaid: 0,
		insnote: false,
		noprogsel: false,
		loading: false,
		errMessage: false,
		errShow: false,
		cseen: false,
		aseen: {},
		anote: [],
		cnote: [],
		progsel: {},
		modsel: [],
		progetti: [],
		moduli: [],
		alunni: [],
		voti: {},
		medie: {},
		docs: [],
		vdescr: [],
		vhmdescr: [],
		mvdescrShow: false,
		mvdescr: { mid: false, data: false, descr: "" },
		dmvdescr: "",
		dforzamedia: false,
		dforzamediadel: false,
		daddvoto: false,
		dwhat: {},
		dwhatv: {},
		showmedie: true,
		barcache: {},
		barmediacache: {},
		forceUpdate: 0,
		cals: [], // elenco orario-modulo
		pres: {}, // elenco presenze ( pres[corsista]['09:00'] = { presenteoraintera: false, giustificato:true })
		dismissCountDown: 0,
		dismissCountDown2: 0,
		// ----- dati per la dialog modifica moduli e microprogettazione
		insmod: false,
		insmodRO: false,
		currmod: false,
		availmods: [],
		microprog: [],
		htmlcon: "",
		showcon: false,
		availcons: [],
		votiuf: [], // voti delle uf calcolati (per ENAC) con rapporto 30/70 fra hm e classe
		currcal: false,
        currcon: false,
		currarg: false,
		availargs: [],
		argomento: "",
		eliminaobj: false,
		soloquestoalunnoid: false,
		soloquestomoduloid: false,
		docOK: false,
		forzaDoc: false,
		modcomp: [], // tabella di corrispondenza fra moduli in comune
		modulijoin: {},
		saving: [],
        giustifiche: [],
        giustifichedett: [], // dettaglio su entra/esce e ora
    };
  },
  props: ["noframe"],
  watch: {
    dwhatv: function(newVal, oldVal) {
      // watch it
        this.dwhatv;
      if (newVal.cancel) {
        this.daddvoto = false;
      } else if (newVal.data != "" && !newVal.ro) {
        this.addvoto2();
      }
    }
  },
  filters: {
    itadata: function(value) {
      if (!value || value == "") return "";
      return value
        .split("-")
        .reverse()
        .join("/");
    }
  },
  computed: {
    mediaciclo1(){
        return window.ENAC ? "M.I° ciclo" : "M.Interm."
    },
    mediaciclo2(){
        return window.ENAC ? "M.II° ciclo" : "M.Finale"
    },
    enac(){
      return window.ENAC
    },
    falunni(){
        return this.alunni.filter(a => this.soloquestoalunnoid==false || a.alunnoid==this.soloquestoalunnoid)
    },
    fmodsel(){
        return this.modsel.filter(a => this.soloquestomoduloid==false || a.moduloid==this.soloquestomoduloid)
    },
    delimina: {
      get: function() {
        return !!this.eliminaobj;
      },
      set: function(value) {
        this.eliminaobj = value;
      }
    },
    liv7(){
      return this.getUserLIV()>=7 ? "liv7" : ""
    },
    canchangemod(){
      let cal = this.cals.find(c => c.ora==this.oracorrente)
      console.log("canchangemod",this.cals,cal,this.oracorrente)
      // docid0 contiene l'eventuale docente sostituito per malattia: se esiste allora si tratta di una supplenza a NON devo poter cambiaree il modulo !!
      return !!cal && !cal.docid0
    },
    insargokdis(){
      return this.argomento.trim()=="" || this.insmodRO
    },
    loctime(){
      if(window.DEBUG)
        return window.loctime || DateTime.local()
      else
        return window.loctime_par || DateTime.local() // loctime passato come parametro (per debug, ma su versione di produzione)
    },
    primaora(){
      if(this.cals && this.cals.length>0)
        return this.cals[0].ora==this.oracorrente
      else
        return false
    },
    modfad(){
      return window.MODFAD=='1'
    },
    secsem(){
      return window.FORMVOTIALUNNI_PRIMOSEMESTRE!='1' ? true : false
    },
    caninsert: function() {
      return window.FORMVOTIALUNNI_CANINSERT==1 && !this.tuttochiuso;
    },
    divstyle: function() {
      return `height: calc(100vh - ${this.noframe ? 50 : 180}px);`;
    },
    gnote: function() {
      if (this.notaaid == 0) {
        return this.cnote;
      } else {
        return this.anote.filter(n => n.alunnoid == this.notaaid);
      }
    },
    loctimeSQL(){
      return this.loctime.toFormat('yyyy-MM-dd HH:mm:ss')
    },
    locdateSQL(){
      return this.loctime.toFormat('yyyy-MM-dd')
    },
    adesso: function() {
      return this.loctime
        .plus({ days: 1 })
        .toISODate();
    },
    oracorrente: function(){
      // se ho già il calendario, calcolo l'ora corrente in base a quello (per tenere conto delle mezz'ore)
      if(this.cals && this.cals.length>0) {
        let adesso = this.loctime.get('hour')*60 + this.loctime.get('minute')
        console.log("adesso",adesso)
        for(let c of this.cals) {
          let cora = c.ora.split(":")[0]*60 + c.ora.split(":")[1]*1
          console.log(c.ora,c.ora.split(":")[0]*60,cora, cora-adesso)
          if(adesso>cora && adesso-cora<60) {
            return c.ora
          }
        }
        // return ""
        // let ora = this.loctime.toFormat('HH')
        // let c = this.cals.find(c => c.ora.startsWith(ora))
        // if(c)
        //   return c.ora
      }
      return this.loctime.toFormat('HH:00')
    },
    mindata: function(){
      if(this.forceUpdate<0) return null; // serve solo per attivare la chiamata
      // la routine si mangia un giorno
      let ret = DateTime.fromISO(window.FORMVOTIALUNNI_PRIMOSEMESTRE==1 ? 
                  window.FORMVOTIALUNNI_dpickerannomin+'-' + window.FORMVOTIALUNNI_dpickermesemin + '-' + window.FORMVOTIALUNNI_dpickergiornomin
                  :
                  window.FORMVOTIALUNNI_DATAFINESEM+'T23:59:59.999').plus({ days: 1 }).toISODate();
      console.log("mindata",ret,this.forceUpdate)
      return ret
    }
  },
  methods: {
	  splitargs(args){ // gli argomenti
		let ret = args ? args.split("|").map( (a,i) => ({argid: i, text: a})) : []
		console.log("availargs",ret)
		return ret
	  },
      async opencon(e) {
          e.preventDefault()
          var td = this.getTokenData()
          var schema = td.sub.schema
          console.log("opencon", window.baseurl)
          let server = '127.0.0.1'
          if(this.ENAC) server='https://swone.cfpcanossa.it' 
          else if(this.ECFOP) server='https://swone.ecfop.it'
          else if(this.GREEN) server='https://swone.fondazionegreen.it/'
          var response = await this.$http.get(`${server}/FormModuli.php?scon=1&cc=${this.currmod.moduloid}&schema=${schema}`)
          console.log("RESPONSE", response)
          this.htmlcon = response.data
          this.showcon = true
      },
      async setmod(c) { // serve a scegliere il modulo  e/o ad impostare conoscenza ed argomento
          console.log("setmod", c, this.oracorrente)
          let cal = this.cals.find(c => c.ora == this.oracorrente)
          this.curcal = cal
          console.log("cal", cal, this.getUserID(), this.getUserLIV())
		//   console.log("cals", this.cals)

            if(c.docid!=this.getUserID() && this.getUserLIV()<2) {
                this.viewmod(c)
              	return
            }
          // i moduli previsti secondo il docente a calendario  

          // verifico se è un modulo doppio
          let mdbl = !!this.modulijoin[c.moduloid]
          console.log("isDBL:", mdbl)

          var mods
          if(this.ENAC) {
            mods = await API.sqlprep(this, "registroc.selmodsdoc", [this.progsel.progettoid, this.progsel.progettoid, c.docid]);
            // ora ho le ore del modulo, quelle del calendario e quelle dell'incarico... filtro i moduli che non posso selezionare (ma lascio quello corrente!)
            // 2024-10-17: solo i moduli che hanno ancora ore di incarico disponibili
            mods.data.dati = mods.data.dati.filter(m => m.moduloid == c.moduloid || m.orecaltodo>0)
          } else {
            mods = await API.sqlprep(this, "registro.selmodsdoc", [this.progsel.progettoid, c.docid]);
          }
          if (mdbl)
              this.availmods = mods.data.dati.filter(m => !!this.modulijoin[m.moduloid])
          else
              this.availmods = mods.data.dati.filter(m => !this.modulijoin[m.moduloid])

          console.log("availmods!", this.availmods)
          await this.favmodsel()
          console.log("favmodsel called")
          this.currmod = this.availmods.find(am => am.moduloid == c.moduloid)
          console.log("currmod!", this.currmod)
          // vedo se avevo già salvato qualcosa

          var args = await API.sqlprep(this, "registro.selarg", [c.calid]);
          if (args.data.dati.length > 0) {
              this.argomento = args.data.dati[0].argomento
              let modid = args.data.dati[0].moduloid
              let mmpid = args.data.dati[0].mmpid
              let mmps = await API.sqlprep(this, "registro.selmicro", [modid]);
              this.currcon = mmps.data.dati.find(m => m.mmpid == mmpid)
			  console.log("currcon",this.currcon)
			  // gli argomenti prima erano gli "strumenti"
			  this.availargs = this.splitargs(this.currcon.strumenti)
              this.currarg = this.availargs.find(aa => aa.text==args.data.dati[0].argomento)
          } else {
              this.argomento = ""
			  this.currarg = false
              this.favmodsel()
          }
          this.insmodRO = false
          this.insmod = true
		  this.oraToSave = c.ora // NON devo salvare l'ora corrente, ma quella che ho editato !
          this.docOK = c.docid == this.getUserID()
      },
      async viewmod(c) { // serve SOLO a vedere modulo, conoscenza ed argomento
          console.log("viewmod", c)
          var mods = await API.sqlprep(this, "registro.selmodsdoc", [this.progsel.progettoid, c.docid]);
          this.availmods = mods.data.dati
          console.log("availmods", this.availmods)
          this.currmod = this.availmods.find(am => am.moduloid == c.moduloid)
          console.log("currmod", this.currmod)
          // vedo se avevo già salvato qualcosa
          var args = await API.sqlprep(this, "registro.selarg", [c.calid]);
          console.log("args:", args.data.dati)
          if (args.data.dati.length > 0) {
              this.argomento = args.data.dati[0].argomento
              let modid = args.data.dati[0].moduloid
              let mmpid = args.data.dati[0].mmpid
              let mmps = await API.sqlprep(this, "registro.selmicro", [modid]);
              this.currcon = mmps.data.dati.find(m => m.mmpid == mmpid)
			  console.log("currcon",this.currcon)
			  this.availargs = this.splitargs(this.currcon.strumenti)
			  this.currarg = this.availargs.find(aa => aa.text==args.data.dati[0].argomento)
          } else {
              this.argomento = ""
              this.currcon = false
              this.currarg = false
              this.favmodsel()
          }
          this.insmodRO = true
          this.insmod = true
      },
      async favmodsel() {
          console.log("scelto un altro modulo", this.currmod)
          if (this.currmod) {
              var mmp = await API.sqlprep(this, "registro.selmicro", [
                  this.currmod.moduloid,
              ]);
              this.availcons = mmp.data.dati
          } else {
              this.availcons = []
          }
          this.currcon = null
          this.currarg = null
          this.argomento = ''
      },
      async favconsel() {
          console.log("scelta un'altra conoscenza", this.currcon)
          if (this.currcon) {
            this.availargs = this.splitargs(this.currcon.strumenti)
            this.currarg = null
            this.argomento = ''
          }
      },
      async favargsel() {
          console.log("scelto l'argomento", this.currarg)
          if (this.currarg) {
            this.argomento = this.currarg.text
          } else {
            this.argomento = ''
          }
      },
      async savemod() {
          // se non è il doc corretto, chiedo una conferma !
          if (!this.docOK) {
              this.forzaDoc = true
              return
          }
          console.log("aggiorno i dati", this.currcon, this.cals, this.oracorrente, this.oraToSave)
          let cal = this.cals.find(c => c.ora == this.oraToSave)
          let cmid = this.currmod.moduloid // il modulo potrebbe NON essere quello del calendario
          // la salvaarg si occupa anche di aggiornare il modulo a calendario, se serve
          // divisa in 5 chiamate perché è formata da più statements
          var res
          res = await API.sqlprep(this, "registro.salvaarg1", []);
          res += await API.sqlprep(this, "registro.salvaarg2", [cal.calid]);
          res += await API.sqlprep(this, "registro.salvaarg3", [cmid, cal.calid]);
          res += await API.sqlprep(this, "registro.salvaarg4", [cal.calid, this.currcon ? this.currcon.mmpid : null, !this.ECFOP ?  this.argomento : (this.currarg ? this.currarg.text : ""), cmid]);
          res += await API.sqlprep(this, "registro.salvaarg5", []);
          console.log("RES", res)
          // se ho cambiato il modulo, devo ricaricare i cals
          if (cal.moduloid != cmid) {
              console.log("Il modulo è cambiato....")
              if(this.ECFOP) {
                var cals = await API.sqlprep(this, "registro.selcalnostage", [
                  this.progsel.progettoid,
                  this.loctimeSQL
               ]);

              } else {
                var cals = await API.sqlprep(this, "registro.selcal", [
                    this.progsel.progettoid,
                    this.loctimeSQL
                ]);

              }
              console.log("CALS", cals.data.dati)
              this.cals = cals.data.dati
          }
          this.insmod = false
      },
      countDownChanged(dismissCountDown) {
          this.dismissCountDown = dismissCountDown
      },
      countDownChanged2(dismissCountDown2) {
          this.dismissCountDown2 = dismissCountDown2
      },
	  async salvaPres(alunnoid, calid, presenteoraintera){
        console.log("salvaPres",alunnoid,calid,presenteoraintera)
		this.$set(this.saving, alunnoid, true)
        let giustificato = this.giustifiche.includes(alunnoid) && presenteoraintera!==true ? 1 : 0
		if(presenteoraintera!==null) 
            presenteoraintera = presenteoraintera ? 1 : 0
        else if(giustificato)
            presenteoraintera = 1
		await API.sqlprep(this, "registro.inspres", [ alunnoid, calid, presenteoraintera, giustificato ]);
		await API.sqlprep(this, "registro.inspres2",[ presenteoraintera, giustificato, alunnoid, calid ]);
		this.$set(this.saving, alunnoid, false)
		setTimeout(()=>{
			this.$set(this.saving, alunnoid, null)
		},1000)
	  },
      gval(v) { // serve per il combo presenza
		// se calendarioid==null devo "indovinare" il valore in base ai dati precedenti
		if(v.calendarioid==null){
            // 20240123: se è ecfop ed è uno stage l'ora NON c'è in cals. Verifico, così se è stage NON salvo la presenza
            let salvo = true
            if(!this.cals.find(c => c.calid==v.calid)) salvo = false
			let a = this.alunni.find(a => a.corsistaid == v.corsistaid)
			if(!a) return "NO"
			let pres = this.pres['c'+v.corsistaid]
			let ore = Object.keys(pres)

			let idx = ore.indexOf(v.ora)
			if(idx==0) {
				// prima ora di questo corsista: salvo e ritorno SI
                // se salvo il default è SI, altrimenti (stage) NO !!
				if(salvo) {
                    this.salvaPres(a.alunnoid,v.calid,true,false)
				    v.presenteoraintera = true
                } else {
				    v.presenteoraintera = null
                }
                v.giustificato = false
				v.calendarioid = v.calid
				return salvo ? "SI" : "NO"
			}
			// recupero il valore dell'ora prima
			let presPrima = this.gval(pres[ore[idx-1]])
			if(presPrima!="NI") {
				if(salvo) {
                    this.salvaPres(a.alunnoid,v.calid,presPrima=="SI" ? true : null)
				    v.presenteoraintera = presPrima=="SI" ? true : null
                } else {
                    v.presenteoraintera = null
                }
				v.giustificato = false
				v.calendarioid = v.calid
				return presPrima
			} else { // ritorno il contrario del valore prima prima oppure SI
				if(idx<2) {
					if(salvo) {
                        this.salvaPres(a.alunnoid,v.calid,true)
					    v.presenteoraintera = true
                    } else {
                        v.presenteoraintera = null
                    }
					v.giustificato = false
					v.calendarioid = v.calid
					return "SI"
				} else {
					let presPrimaPrima = this.gval(pres[ore[idx-2]])
					if(salvo) {
                        this.salvaPres(a.alunnoid,v.calid,presPrimaPrima=="SI" ? null : true)
					    v.presenteoraintera = presPrimaPrima=="SI" ? null : true
                        v.giustificato = pres[ore[idx-2]].giustificato
                    } else {
                        v.presenteoraintera = null
                        v.giustificato = false
                    }
					v.calendarioid = pres[ore[idx-2]].calendarioid
					return presPrimaPrima=="SI" ? "NO" : "SI"
				}
			}
		}

          if (v.presenteoraintera && !v.giustificato)
              return "SI"
          else if (v.presenteoraintera === false)
              return "NI"
          else
              return "NO"
      },
      svalc(cid, ora, value) { // serve per il combo presenza
          let v = value.target.checked
          console.log("checkval", cid, ora, v)
          let obj = this.pres[cid]
          obj[ora].giustificato = v
          if (v && obj[ora].presenteoraintera === null)
              obj[ora].presenteoraintera = true
          if (!v && obj[ora].presenteoraintera !== false)
              obj[ora].presenteoraintera = null
          this.$set(this.pres, cid, obj)

      },
      async giustificadett1(aid, value){
        this.$set(this.saving, aid, true)
        let v = value.target.value
        console.log("giustificadett1",aid,v)
        let t = this.giustifichedett[aid]
        t.entra = v
        this.$set(this.giustifichedett, aid, t)
        try { await API.sqlprep(this, "registro.giustifica_when", [t.entra=='1' ? 'true' : 'false',t.ora,aid, this.locdateSQL]); } catch (error) { }
        setTimeout(()=>{
	    		this.$set(this.saving, aid, null)
   		},1000)
      },
      async giustificadett2(aid, value){
        this.$set(this.saving, aid, true)
        let v = value.target.value
        console.log("giustificadett2",aid,v)
        let t = this.giustifichedett[aid]
        t.ora = v
        this.$set(this.giustifichedett, aid, t)
        try { await API.sqlprep(this, "registro.giustifica_when", [t.entra=='1' ? 'true' : 'false',t.ora,aid, this.locdateSQL]); } catch (error) { }
        setTimeout(()=>{
	    		this.$set(this.saving, aid, null)
   		},1000)
      },
      async giustifica(aid, value){
          this.$set(this.saving, aid, true)
          let v = value.target.value
          console.log("giustifica",aid,v)
            if(v == 'NO') {
                // rimuovo l'alunno id dall'array delle giustifiche
                this.giustifiche = this.giustifiche.filter(g => g != aid)
                try {
                  await API.sqlprep(this, "registro.giustifica_no", [aid, this.locdateSQL]);
              } catch (error) { }
            } else {
                this.giustifiche.push(aid)
                try {
                  await API.sqlprep(this, "registro.giustifica_si", [aid, this.locdateSQL]);
              } catch (error) { }
            }
            setTimeout(()=>{
	    		this.$set(this.saving, aid, null)
    		},1000)
      },
      sval(cid, ora, value) { // serve per il combo presenza
          let v = value.target.value
          let obj = this.pres[cid]
          if (v == 'NO') {
              obj[ora].presenteoraintera = null
              obj[ora].giustificato = false
          } else if (v == 'NI') {
              obj[ora].presenteoraintera = false
          } else {
              obj[ora].presenteoraintera = true
              obj[ora].giustificato = false
          }
          console.log("sval", cid, ora, v, obj[ora])
          this.$set(this.pres, cid, obj)
		  let a = this.alunni.find(a => a.corsistaid == obj[ora].corsistaid)
		  if(a) // potrebbe essere ritirato
		  	this.salvaPres(a.alunnoid, obj[ora].calid, obj[ora].presenteoraintera)
      },
      async savefad(value, alunnoid, ind) {
          console.log("SAVEFAD", value, alunnoid, ind)
          let score = this.fad.filter(f => f.indicatore == ind && f.testo == value)[0].score
          if (score < 0) {
              try {
                  await API.sqlprep(this, "registro.faddel", [alunnoid, ind]);
              } catch (error) { }
          } else {
              try {
                  await API.sqlprep(this, "registro.fadins", [this.getUserID(), score, ind, alunnoid]);
              } catch (error) { }
              try {
                  await API.sqlprep(this, "registro.fadupd", [this.getUserID(), score, ind, alunnoid]);
              } catch (error) { }
          }
      },
      selOpts(ind) {
          return this.fad.filter(f => f.indicatore == ind).map(f => f.testo)
      },
      async updateNote() {
          var alids = this.alunni.map(a => a.alunnoid).join();
          var cnote = await API.sqlprep(this, "registro.getCnote", [
              this.progsel.progettoid
          ]);
          var anote = await API.sqlprep(this, "registro.getAnote", [], {
              "@alids": alids
          });
          this.cnote = cnote.data.dati;
          this.anote = anote.data.dati;
      },
      async addnota2() {
          this.insnote = false;
          if (!this.tuttochiuso) {
              if (this.notaaid == 0) {
                  await API.sqlprep(this, "registro.addCnote", [
                      this.progsel.progettoid,
                      this.insdata,
                      this.getUserID(),
                      this.insnota
                  ]);
              } else {
                  await API.sqlprep(this, "registro.addAnote", [
                      this.notaaid,
                      this.insdata,
                      this.getUserID(),
                      this.insnota
                  ]);
                  if (window.ENAC) { // manda la nota anche come messaggio
                      // recupero il corsistaid
                      let cid = this.alunni.find(a => a.alunnoid == this.notaaid).corsistaid
                      // genero data-ora in formato italiano
                      let dataora = this.loctime.toFormat('dd/MM/yyyy HH:mm')
                      // recupero il nome del docente
                      let doc = this.getUserName()
                                              
                      await API.sqlprep(this, "messaggi.send", [
                          cid,
                          this.insnota + "<br>" + dataora + "<br>" + doc,
                          '',
                          this.getUserID(),
                      ]);
                  }
              }
          }
          this.updateNote();
      },
      seenclass(aid) {
          if (aid == 0) {
              if (this.cseen) return "clickme";
              else return "clickme blink";
          } else {
              if (this.aseen["A" + aid]) return "clickme";
              else return "clickme blink";
          }
      },
      addnota(aid) {
          if (aid > 0) {
              this.aseen['A' + aid] = true
              API.sqlprep(this, "registro.seenAnote", [
                  aid, this.getUserID()
              ]);
          } else {
              this.cseen = true
              API.sqlprep(this, "registro.seenCnote", [
                  this.progsel.progettoid, this.getUserID()
              ]);
          }
          this.notaaid = aid;
          this.insnota = "";
          this.insnote = true;
      },
      showmedieev: async function (ev) {
          var me = this;
          setTimeout(function () {
              me.showmedie = ev.value;
          }, 100);
      },
      barmedia: function (aid, mid) {
          if (this.barmediacache[aid + "_" + mid])
              return this.barmediacache[aid + "_" + mid];
          var d = this.bardata(aid, mid, 2);
          var t = Math.round(d.reduce((a, v) => a + v / 8.0, 0));
          var col = "rgba(1,1,1,0);";
          switch (t) {
              case 1:
                  col = "red";
                  break;
              case 2:
                  col = "orange";
                  break;
              case 3:
                  col = "green";
                  break;
              case 4:
                  col = "lightseagreen";
                  break;
          }
          this.barmediacache[aid + "_" + mid] = `width: 50px;height: 25px;background-color: ${col};display: inline-block;position: relative;top: 10px;left:10px;`;
          return this.barmediacache[aid + "_" + mid]
      },
      clearBarCache(aid, mid) {
          this.barcache[aid + "_" + mid + "_1"] = false;
          this.barcache[aid + "_" + mid + "_2"] = false;
          this.barcache[aid + "_" + mid + "_1O"] = false;
          this.barcache[aid + "_" + mid + "_2O"] = false;
          this.barcache[aid + "_0_1"] = false;
          this.barcache[aid + "_0_2"] = false;
          this.barcache[aid + "_0_1O"] = false;
          this.barcache[aid + "_0_2O"] = false;
      },
      bardata: function (aid, mid, quad) {
          if (this.barcache[aid + "_" + mid + "_" + quad])
              return this.barcache[aid + "_" + mid + "_" + quad];
          if (mid === "media") {
              var k = 0.0;
              var ret = [0, 0, 0, 0, 0, 0, 0, 0];
              this.modsel.forEach(m => {
                  let mid = m.moduloid;
                  var v = this.bardata(aid, mid, quad);
                  if (v[0] > 0) {
                      for (let i = 0; i < 8; i++) ret[i] += v[i];
                      k++;
                  }
              });
              if (k > 0) {
                  for (let i = 0; i < 8; i++) ret[i] = Math.round(ret[i] / k);
              }
              this.barcache[aid + "_" + mid + "_" + quad] = ret;
              return ret;
          }

          var ret = [0, 0, 0, 0, 0, 0, 0, 0];
          var k = 0;
          if (this.voti["A" + aid]["M" + mid]) {
              this.voti["A" + aid]["M" + mid].map(v => {
                  if (!v.hasOwnProperty("valut")) return;
                  if (v.data > window.FORMVOTIALUNNI_DATAFINESEM && quad == 1) return;
                  var tmp = JSON.parse(v.valut);
                  if (!tmp) return;
                  for (let i = 0; i < 8; i++) {
                      ret[i] += tmp["data" + (i + 1)] * 1;
                  }
                  k++;
              });
          }
          if (k == 0) {
              this.barcache[aid + "_" + mid + "_" + quad] = [0, 0, 0, 0, 0, 0, 0, 0];
              return [0, 0, 0, 0, 0, 0, 0, 0];
          }
          for (let i = 0; i < 8; i++) {
              ret[i] /= k;
              ret[i] = Math.max(1, Math.round(ret[i]));
          }
          this.barcache[aid + "_" + mid + "_" + quad] = ret;
          return ret;
      },
      baropts: function (aid, mid, quad) {
          if (this.barcache[aid + "_" + mid + "_" + quad + "O"]) {
              return this.barcache[aid + "_" + mid + "_" + quad + "O"];
          }
          var v = this.bardata(aid, mid, quad);
          //var ret = { fill: v.map( t => { if(t==1) return "red"; if(t==2) return "orange"; if(t==3) return "green"; return "lightseagreen"}), width: 50, height: 25, max: 4 };
          var ret = {
              fill: function (t) {
                  if (t == 1) return "red";
                  if (t == 2) return "orange";
                  if (t == 3) return "green";
                  return "lightseagreen";
              },
              width: 50,
              height: 25,
              max: 4
          };
          this.barcache[aid + "_" + mid + "_" + quad + "O"] = ret;
          return ret;
      },
      showvoto: async function (voto) {
          var ret = await API.sqlprep(
              this,
              window.ENAC ? "registroc.carica" : "registro.carica",
              window.ENAC ? [voto.alunnoid, voto.moduloid, voto.data, voto.alunnoid] : [voto.moduloid, voto.data, voto.alunnoid],
              { "@hm": voto.hm ? "hm" : "" }
          );
          ret.data.dati.map(r => r.moduloid = r.moduloid || r.modulocompid)// ENAC
          var d = ret.data.dati[0];
          let datac
          if (d.moduloid < 0)
              datac = this.dataChiuso2
          else
              datac = this.dataChiuso
          var dwv = {
              aid: d.alunnoid,
              mid: d.moduloid,
              hm: voto.hm,
              ro: datac > voto.data || voto.chiusura || voto.chiusura1 || voto.chiusura2 || d.moduloid == 999999 || this.tuttochiuso, // non posso modificare le modfad perché le inseriscono in tanti
              voto: d.voto,
              data: d.data,
              oggetto: voto.descr
          };
          if (d.valut) dwv = Object.assign(dwv, JSON.parse(d.valut));
          dwv.update = false
          dwv.oldvoto = true
          this.dwhatv = dwv;
          this.daddvoto = true;
      },
      medieclass: function (sem1) {
          if (sem1) return window.FORMVOTIALUNNI_PRIMOSEMESTRE == 1 && !this.tuttochiuso ? "voto clickme" : "voto";
          else return window.FORMVOTIALUNNI_SECONDOSEMESTRE == 1 && !this.tuttochiuso ? "voto clickme" : "voto";
      },
      medievotoclass: function (sem1) {
          if (sem1)
              return window.FORMVOTIALUNNI_PRIMOSEMESTRE == 1 && !this.tuttochiuso ? "datavoto clickme" : "datavoto";
          else
              return window.FORMVOTIALUNNI_SECONDOSEMESTRE == 1 && !this.tuttochiuso ? "datavoto clickme" : "datavoto";
      },
      canforcemedia(sem1) {
          let ret = this.caninsert && (sem1 ? window.FORMVOTIALUNNI_PRIMOSEMESTRE == 1 : window.FORMVOTIALUNNI_SECONDOSEMESTRE == 1) && !this.tuttochiuso;
          console.log("force?", sem1, window.FORMVOTIALUNNI_PRIMOSEMESTRE, window.FORMVOTIALUNNI_SECONDOSEMESTRE)
          return ret
      },
      chiuso(p) {
          // console.log("TUTTOCHIUSO",this.tuttochiuso)
        // console.log("CHIUSO", this.dataChiuso, p.data, p.chiusura, p.chiusura1, p.chiusura2, this.tuttochiuso)
          return this.dataChiuso >= p.data || p.chiusura || p.chiusura1 || p.chiusura2 || this.tuttochiuso; // pagellahm o pagella
      },
      chiuso2(p) {
          // console.log("TUTTOCHIUSO2",this.tuttochiuso)
        // console.log("CHIUSO2", this.dataChiuso2, p.data, p.chiusura, p.chiusura1, p.chiusura2, this.tuttochiuso)
          return this.dataChiuso2 >= p.data || p.chiusura || p.chiusura1 || p.chiusura2 || this.tuttochiuso; // pagellahm o pagella
      },
      addvoto(aid, mid) {
          this.dwhatv = { aid: aid, mid: mid };
          this.daddvoto = true;
          console.log("SHOW...");
      },
      async addvoto2() {
          var hm = this.dwhatv.hm;
          var v = this.dwhatv.voto;
          if (!v && v != "0") return;
          var d = this.dwhatv.mid >= 0 ? this.dwhatv.data.substring(0, 10) : "";
          if (!this.dwhatv.oldvoto || this.dwhatv.update) {
              var ret = await this.salva(hm, this.dwhatv.aid, this.dwhatv.mid, v, d);
              await this.salvavalut(ret);
              this.daddvoto = false;
          }
          return ret;
      },
      forzamedia(aid, mid, quad) {
          this.dwhat = { aid: aid, mid: mid, quad: quad };
          console.log("DWHAT<-", this.dwhat)
          if (this.medie["A" + aid]["M" + mid + "_" + quad])
              this.dforzamediadel = true;
          else this.dforzamedia = true;
      },
      forzamediaclass(aid, mid, quad) {
          if (this.medie["A" + aid]["M" + mid + "_" + quad])
              return "mediaforced";
          else
              return ""
      },
      forzamedia2: async function () {
          var dmedia = this.$refs.dforzamedia.value;
          console.log("DWHAT->", this.dwhat)
          var ret = await API.sqlprep(this, window.ENAC ? "registroc.insmedie" : "registro.insmedie", [
              this.dwhat.aid,
              this.dwhat.mid,
              dmedia,
              this.getUserID(),
              this.dwhat.quad == 1 ? "0" : "1"
          ]);
          if (!this.testErr(ret)) {
              this.medie["A" + this.dwhat.aid][
                  "M" + this.dwhat.mid + "_" + this.dwhat.quad
              ] = {};
              console.log(
                  "REF:",
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MV" + this.dwhat.quad,
                  this.$refs[
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MV" + this.dwhat.quad
                  ]
              );
              this.$refs[
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MV" + this.dwhat.quad
              ][0].innerHTML = "" + dmedia;
              this.$refs[
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MD" + this.dwhat.quad
              ][0].innerHTML = this.loctime.toFormat("dd/LL/yyyy");
          }
      },
      forzamediadel: async function () {
          var ret = await API.sqlprep(this, window.ENAC ? "registroc.forzamediadel" : "registro.forzamediadel", [
              this.dwhat.aid,
              this.dwhat.mid,
              this.dwhat.quad == 1 ? 0 : 1
          ]);
          if (!this.testErr(ret)) {
              delete this.medie["A" + this.dwhat.aid][
                  "M" + this.dwhat.mid + "_" + this.dwhat.quad
              ];
              this.$refs[
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MV" + this.dwhat.quad
              ][0].innerHTML =
                  this.media(this.dwhat.aid, this.dwhat.mid, this.dwhat.quad) +
                  "&nbsp;";
              this.$refs[
                  this.dwhat.aid + "_" + this.dwhat.mid + "_MD" + this.dwhat.quad
              ][0].innerHTML = "&nbsp;";
          }
      },
      mediatitle: function (aid, mid, quad) {
          if (this.medie["A" + aid]["M" + mid + "_" + quad]) {
              return this.medie["A" + aid]["M" + mid + "_" + quad].nome;
          }
          return "";
      },
      mediadata: function (aid, mid, quad) {
          if (this.medie["A" + aid]["M" + mid + "_" + quad]) {
              return this.medie["A" + aid]["M" + mid + "_" + quad].data;
          }
          return "";
      },
      media: function (aid, mid, quad) {
          if (this.medie["A" + aid]["M" + mid + "_" + quad]) {
              return this.medie["A" + aid]["M" + mid + "_" + quad].voto;
          }
          var s1 = 0,
              t1 = 0,
              s2 = 0,
              t2 = 0;
          if (!this.voti["A" + aid]["M" + mid]) return 0
          this.voti["A" + aid]["M" + mid].map(v => {
              if (!v.hasOwnProperty("voto")) return;
              var peso
              if (window.ENAC)
                  peso = v.hm ? 1 : 2; // hanno chiesto 30/70, così è 33 / 66, più facile da controllare
              else
                  peso = v.hm ? 1 : 4;
              if (v.data <= window.FORMVOTIALUNNI_DATAFINESEM) { // per ENAC viene settata dall'esistenza dello scrutinio
                  s1 += v.voto * peso;
                  t1 += peso;
              } else {
                  s2 += v.voto * peso;
                  t2 += peso;
              }
          });
          if (t1 == 0) t1 = 1;
          if (t2 == 0) t2 = 1;
          //20160427: media finale pesata su 40-60 (verificare javascript['updateMedie'], php e report finale)
          let s1_0 = false;
          if (s1 == 0) s1 = s2, t1 = t2, s1_0 = true
          if (s2 == 0) s2 = s1, t2 = t1
          var m1 = s1 / t1;
          var m2 = s2 / t2;
          //$total2 = $total1 * 0.4 + ($sum2-$sum1)/(max($count2-$count1,1))*0.6;
          
          m2 = m1 * 0.4 + m2 * 0.6;

          if(s1_0 && window.ECFOP)
            m1 = 0

          return quad == 1 ? Math.round(m1) : Math.round(m2);
      },
      selall: function () {
          this.modsel = [].concat(this.moduli);
          localStorage.setItem(
              "registro_pid" + this.progsel.progettoid,
              JSON.stringify(this.modsel)
          );
      },
      selpers: function (gen) {
          console.log(this.moduli);
          var id = this.getUserID();
          this.modsel = [].concat(
              this.moduli.filter(m => {
                  if (!m.docids) return gen;
                  var ids = m.docids.split(",");
                  console.log("??", ids, m);
                  return ids.indexOf(id) >= 0;
              })
          );
          localStorage.setItem(
              "registro_pid" + this.progsel.progettoid,
              JSON.stringify(this.modsel)
          );
      },
      stilevoto: function (v, m) {
          if (v) {
              var r, g, b;
              if (v <= 20) {
                  g = 0;
                  r = 255;
              } else if (v > 20 && v <= 50) {
                  g = (255 * v) / 50;
                  r = 255;
              } else {
                  g = 255;
                  r = (255 * (100 - v)) / 50;
              }
              b = 2;
              // il pf5 va da 0 a 30
              /*
              if ($(this).hasClass("pf5")) {
                if (voto <= 0.2 * 30) {
                  g = 0;
                  r = 255;
                } else if (voto > 0.2 * 30 && voto <= 0.5 * 30) {
                  g = (255 * voto) / (0.5 * 30);
                  r = 255;
                } else {
                  g = 255;
                  r = (255 * (30 - voto)) / (0.5 * 30);
                }
              }
              */

              // il pwork va da 0 a 1
              if (m == -1) {
                  g = 255 * v;
                  r = 255 * (1 - v);
              }
              var bin = (r << 16) | (g << 8) | b;
              var col = bin.toString(16).toUpperCase();
              //console.log('COL:',col,r,g,b,voto)
              col = new Array(7 - col.length).join("0") + col;
              return `background-color: #${col};`;
          } else {
              return "";
          }
      },
      elimina: async function (home, aid, mid, d, i) {
          this.eliminaobj = {
              home: home,
              aid: aid,
              mid: mid,
              d: d,
              i: i
          }
      },
      elimina2: async function () {
          let { home, aid, mid, d, i } = this.eliminaobj
          var ret
          if (window.ENAC) {
              ret = await API.sqlprep(this, "registroc.elimina", [aid, mid, d, aid], {
                  "@hm": home ? "hm" : ""
              });
          } else {
              ret = await API.sqlprep(this, "registro.elimina", [mid, d, aid], {
                  "@hm": home ? "hm" : ""
              });
          }
          if (!this.testErr(ret)) {
              this.voti["A" + aid]["M" + mid].splice(i, 1);
          }
          this.clearBarCache(aid, mid)
      },
      note2: async function (descr) {
          var sql;
          var pars;
          var ddescr = descr || this.$refs["mvdescrShow"].value;
          var repls;
          if (this.mvdescr.nuovo) {
              var tmp = { default: ddescr };
              tmp["a" + this.mvdescr.aid] = ddescr;
              var json = JSON.stringify(tmp);
              repls = { "@hm": this.mvdescr.home ? "hm" : "" };
              sql = "registro.note2ins";
              pars = [this.mvdescr.mid, this.mvdescr.data, json];
          } else {
              let json = this.mvdescr.json;
              json["a" + this.mvdescr.aid] = ddescr;
              json = JSON.stringify(json);
              repls = { "@hm": this.mvdescr.home ? "hm" : "" };
              sql = window.ENAC ? "registroc.note2upd" : "registro.note2upd";
              pars = [json, this.mvdescr.mid, this.mvdescr.data];
          }
          var ret = await API.sqlprep(this, sql, pars, repls);
          if (!this.testErr(ret)) {
              // devo usare il mid specifico del progetto, non quello "vero"
              let smid = this.modcomp[this.mvdescr.mid] || this.mvdescr.mid
              var i = this.voti["A" + this.mvdescr.aid]["M" + smid].findIndex(vv => vv.data == this.mvdescr.data && vv.hm == this.mvdescr.home)
              this.voti["A" + this.mvdescr.aid]["M" + smid][i].descr = descr
              var key =
                  this.mvdescr.aid +
                  "_" +
                  this.mvdescr.data +
                  "_VD" +
                  this.mvdescr.home;
              this.$refs[key][0].setAttribute("title", ddescr);
          }
      },
      note: async function (home, aid, mid, d, descr) {
          var ret, prep
          if (window.ENAC) {
            //   ret = await API.sqlprep(this, "registroc.getmodcompid", [aid, mid]);
              // console.log("MID",""+mid,ret.data.dati[0].getmodcompid)
            //   mid = ret.data.dati[0].getmodcompid
              prep = "registroc.selnote" + (home ? "hm" : "");
              ret = await API.sqlprep(this, prep, [mid, d]);
          } else {
              prep = "registro.selnote" + (home ? "hm" : "");
              ret = await API.sqlprep(this, prep, [mid, d]);
          }
          if (ret.data.dati.length > 0) {
              var json = JSON.parse(ret.data.dati[0].descrizione);
              this.mvdescr = {
                  mid: mid,
                  aid: aid,
                  descr: json["a" + aid] || json.default,
                  data: d,
                  json: json,
                  nuovo: false,
                  home: home
              };
          } else {
              this.mvdescr = {
                  mid: mid,
                  aid: aid,
                  descr: "",
                  data: d,
                  nuovo: true,
                  home: home
              };
          }
          if (!descr) {
              this.dmvdescr = this.mvdescr.descr;
              this.mvdescrShow = true;
          } else {
              this.note2(descr);
          }
      },
      salvaneg: function (aid, mid) {
          console.log(
              "???",
              aid,
              mid,
              "A" + aid + "M" + mid + "PW",
              this.$refs["A" + aid + "M" + mid + "PW"]
          );
          var v = this.$refs["A" + aid + "M" + mid + "PW"][0].value;
          console.log("V:", v);
          this.salva(false, aid, mid, v, false);
      },
      salvavalut: async function (el) {
          var aid = this.dwhatv.aid;
          var mid = this.dwhatv.mid;
          var d = this.dwhatv.mid >= 0 ? this.dwhatv.data.substring(0, 10) : "";
          var json = Object.assign({}, this.dwhatv);
          var oggetto = json.oggetto;
          delete json.aid;
          delete json.mid;
          delete json.data;
          delete json.voto;
          delete json.oggetto;
          delete json.hm;
          delete json.cancel;
          delete json.ro;
          delete json.update;
          delete json.oldvoto;
          var sj = JSON.stringify(json);
          var ret = await API.sqlprep(this, window.ENAC ? "registroc.salvavalut" : "registro.salvavalut", [
              sj,
              aid,
              mid,
              d
          ]);
          el.valut = sj;
          this.clearBarCache(aid, mid)
          // console.log("SQLVALUT", ret);
          this.testErr(ret);
          this.note(this.dwhatv.hm, aid, mid, d, oggetto);
      },
      salva: async function (home, aid, mid, v, d) {
          if (mid >= 0 && d == "") return;
          if (v > 100) v = 100;
          if (v < 0) v = 0;
          var sql;
          var pars;
          var repls;
          if (mid == -2 || mid == -3 || mid == -4) {
              // per ora ECFOP le salva al contrario: dovrò aggiustarle aggiornando anche il DB
              var uf = "uf" + (mid + 5);
              if (window.ENAC)
                  uf = "uf" + (-1 - mid);
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": uf }
              );
              repls = { "@uf": uf };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -8 || mid == -9 || mid == -10) {
              // per ora ECFOP NON HA le UF4-6
              var uf = "uf" + (-4 - mid);
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": uf }
              );
              repls = { "@uf": uf };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -8 || mid == -9 || mid == -10) {
              var uf = "uf" + (mid + 14);
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": uf }
              );
              repls = { "@uf": uf };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -1) {
              if (v > 1) v = 1;
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": "pwork" }
              );
              repls = { "@uf": "pwork" };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -5) {
              if (v > 100) v = 100;
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": "condotta" }
              );
              repls = { "@uf": "condotta" };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -7) { //ENAC
              if (v > 100) v = 100;
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": "irc" }
              );
              repls = { "@uf": "irc" };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (mid == -6) { //ENAC
              if (v > 100) v = 100;
              var ret = await API.sqlprep(
                  this,
                  "registro.ppfins",
                  [aid, v, this.getUserID()],
                  { "@uf": "stage" }
              );
              repls = { "@uf": "stage" };
              pars = [v, this.getUserID(), aid];
              sql = "registro.ppfupd";
          } else if (home) {
              repls = { "@hm": "hm" };
              // elimino (in caso di update)
              if (window.ENAC) {
                  pars = [aid, aid, mid, d];
                  await API.sqlprep(this, "registroc.pagelladel", pars, repls);
              } else {
                  pars = [aid, mid, d];
                  await API.sqlprep(this, "registro.pagelladel", pars, repls);
              }
              pars = [aid, mid, d, v, this.getUserID()];
              sql = window.ENAC ? "registroc.pagellains" : "registro.pagellains";
          } else if (mid > 2) {
              // 2020-06-03 - NON faccio update sui 999999 (mod.rel.)
              repls = { "@hm": "" };
              if (mid != 999999) {
                  // elimino (in caso di update)
                  if (window.ENAC) {
                      pars = [aid, aid, mid, d];
                      await API.sqlprep(this, "registroc.pagelladel", pars, repls);
                  } else {
                      pars = [aid, mid, d];
                      await API.sqlprep(this, "registro.pagelladel", pars, repls);
                  }
              }
              pars = [aid, mid, d, v, this.getUserID()];
              sql = window.ENAC ? "registroc.pagellains" : "registro.pagellains";
          } else if (mid >= 0) {
              // elimino (in caso di update)
              pars = [aid, mid, d];
              sql = "registro.pagellaapprdel";
              var ret = await API.sqlprep(this, sql, pars, repls);
              pars = [aid, mid, d, v, this.getUserID()];
              sql = "registro.pagellaapprins";
          }
          var ret = await API.sqlprep(this, sql, pars, repls);
          if (!this.testErr(ret, mid)) {
              if (mid >= 0) {
                  // i voti sono tutti via con il codice del modulo del progetto, anche se sono del progetto parallelo
                  mid = this.modcomp[mid] || mid
                  var l = this.voti["A" + aid]["M" + mid].length;
                  var ret = {
                      alunnoid: aid,
                      moduloid: mid,
                      docenteid: this.getUserID(),
                      voto: v,
                      data: d,
                      hm: home
                  };
                  // cerco il voto: se c'è già lo sostituisco, altrimenti lo aggiorno
                  var i = this.voti["A" + aid]["M" + mid].findIndex(vv => vv.data == d && vv.hm == home)
                  if (i >= 0) {
                      this.voti["A" + aid]["M" + mid][i] = ret
                  } else
                      this.voti["A" + aid]["M" + mid].splice(l - 1, 0, ret);
              }
              return ret;
          } else {
              return false;
          }
      },
      testErr: function (ret, mid) {
          if (ret.data.errInfo[2] !== null || ret.data.cerrInfo[2] !== null) {
              this.errMessage =
                  (ret.data.errInfo[2] || "") + (ret.data.cerrInfo[2] || "");
              if (mid == 999999)
                  this.errMessage = "Errore: data già presente. Utilizzarne una diversa"
              this.errShow = true;
              return true;
          } else {
              return false;
          }
      },
      ifmodsel: function () {
          console.log("MSEL:", this.modsel);
          localStorage.setItem(
              "registro_pid" + this.progsel.progettoid,
              JSON.stringify(this.modsel)
          );
      },
      votouf(alunnoid, uf) {
          try {
              return Math.floor(this.votiuf.find(v => v.alunnoid == alunnoid && v.uf == uf).media)
          } catch (error) {
              // non c'è
              return " - "
          }
      },
      fprogsel: async function () {
          this.modcomp = []
          //this.$nextTick(async () => {
          var me = this;
          this.loading = true;
          console.log("PROGSEL:", this.progsel);

          // aggiorno i parametri tenendo conto che alcuni possono essere specifici al progetto
          await API.getpars(this, this.progsel.sedeid)

          // aggiorno le impostazioni in base alla data scrutinio (se presente nel progetto)
          let adesso = this.loctime

		let vtmp = await API.sqlprep(this, "registro.giustifiche", [this.locdateSQL,this.progsel.progettoid]);
		this.giustifiche = vtmp.data.dati.map(g => g.alunnoid)
		for(let t of vtmp.data.dati)
			this.giustifichedett[t.alunnoid] = { entra:t.entra ? '1' : '0', ora: t.ora}
		console.log("giustifiche!", this.giustifiche, this.giustifichedett)

          if (this.progsel.scrutinio1) {
              let scrutinio1 = DateTime.fromISO(this.progsel.scrutinio1)
              console.log("CHECK DATE1", scrutinio1, adesso)
              window.FORMVOTIALUNNI_PRIMOSEMESTRE = scrutinio1 >= adesso ? '1' : '0'
              window.FORMVOTIALUNNI_SECONDOSEMESTRE = scrutinio1 < adesso ? '1' : '0'
              window.FORMVOTIALUNNI_DATAFINESEM = this.progsel.scrutinio1
              console.log("CHECK1:", window.FORMVOTIALUNNI_PRIMOSEMESTRE, window.FORMVOTIALUNNI_SECONDOSEMESTRE, window.FORMVOTIALUNNI_DATAFINESEM)
              if (scrutinio1 < adesso) {
                  this.dataChiuso = this.progsel.scrutinio1
                  console.log("Chiuso al", this.dataChiuso)
              }
          } else if (window.ENAC) {
              window.FORMVOTIALUNNI_PRIMOSEMESTRE = '1'
              window.FORMVOTIALUNNI_SECONDOSEMESTRE = '0'
              window.FORMVOTIALUNNI_DATAFINESEM = '2099-12-31'
          }
          this.tuttochiuso = !!this.progsel.scrutinio2
          if (this.progsel.scrutinio2) {
              let scrutinio2 = DateTime.fromISO(this.progsel.scrutinio2)
              console.log("CHECK DATE2", scrutinio2, adesso)
              if (scrutinio2 < adesso) {
                  this.dataChiuso2 = this.progsel.scrutinio2
              }
          }
          if (window.ENAC) {
              try {
                  let vtmp = await API.sqlprep(this, "registro.selvotiuf", [this.progsel.progettoid]);
                  this.votiuf = vtmp.data.dati
                  console.log("votiuf", this.votiuf)
              } catch (error) {
                  console.error("Errore caricando i votiuf", error)
              }
          }

          var mods = await API.sqlprep(this, window.ENAC ? "registroc.selmods" : "registro.selmods", [this.progsel.progettoid]);
          var lmods = localStorage.getItem("registro_pid" + this.progsel.progettoid);
          if (!lmods) this.selpers(true);
          this.modsel = [];
          try {
              if (lmods)
                  this.modsel = JSON.parse(lmods);
              else
                  this.modsel = [];
          } catch (error) {
              console.error("error", error)
          }
          mods.data.dati.map(r => r.moduloid = r.moduloid || r.modulocompid)// ENAC
          var moduli = mods.data.dati
              .map(m => ({
                  moduloid: m.moduloid,
                  nome: m.nome,
                  codice: m.codice,
                  area: m.area
              }))
              .sort((a, b) => {
                  if (a.codice < b.codice) return -1;
                  else if (a.codice > b.codice) return 1;
                  else return 0;
              });
          // FAD
          console.log("FPROGSEL")
          if (this.modfad) {
              let t = await API.sqlprep(this, "registro.fad", []);
              this.fad = t.data.dati
              t = await API.sqlprep(this, "registro.fadscores", [this.progsel.progettoid, this.progsel.progettoid, this.progsel.progettoid]);
              this.fadscores = t.data.dati
              this.fadindicatori = this.fad.map(f => f.indicatore).filter((v, i, a) => a.indexOf(v) === i)
              for (let ind of this.fadindicatori)
                  this.fad.unshift({ indicatore: ind, testo: '***', score: -1 })
          }
          // condotta
          var td = me.getTokenData()
          var schema = td.sub.schema
          if ((!this.modfad && this.progsel.nomr) || (!window.ENAC && !window.GREEN && schema >= "a2022")) {
              // 2022-01-30 deciso con Lalla: le valutazioni condotta si inseriscono come modrel, ma poi si inserisce un valore secco nel registro
              moduli.push({
                  moduloid: -5,
                  nome: "Modalità relazionali", // è la condotta
                  codice: "",
                  area: ""
              });
          } else if (this.progsel.nomr) {
              moduli.push({
                  moduloid: 999999,
                  nome: "Condotta",
                  codice: "",
                  area: ""
              });
          } else if (schema == "a2020") {
              moduli.push({
                  moduloid: 999999,
                  nome: "Modalità relazionali",
                  codice: "",
                  area: ""
              });
          }
          // Project Work
          var PWORK = this.progsel.annualita >= "3" && this.getSchema() != 'a2020' && window.ECFOP;
          if (PWORK) {
              moduli.push({
                  moduloid: -1,
                  nome: "Project Work",
                  codice: "",
                  area: ""
              });
          }
          if (this.ENAC) {
              moduli.push({
                  moduloid: -7,
                  nome: "IRC",
                  codice: "",
                  area: ""
              });
              moduli.push({
                  moduloid: -6,
                  nome: "STAGE",
                  codice: "",
                  area: ""
              });
          }
          if (this.modfad) {
              moduli.push({
                  moduloid: 999999,
                  nome: "FAD",
                  codice: "",
                  area: ""
              });
          }
          if (!this.progsel.nouf) {
              for (var j = 2; j <= 4; j++)
                  moduli.push({
                      moduloid: -j,
                      nome: "UF" + (j - 1),
                      codice: "",
                      area: ""
                  });
          }
          if (this.ENAC) {
              for (var j = 8; j <= 10; j++)
                  moduli.push({
                      moduloid: -j,
                      nome: "UF" + (j - 4),
                      codice: "",
                      area: ""
                  });
          }
          // verifica modsel / moduli
          console.log("MODSEL", this.modsel)
          console.log("MODULI", moduli)
          this.modsel = this.modsel.filter(m => !!moduli.find(m2 => m2.moduloid == m.moduloid))

          // ore e moduli della giornata (per attività docente)
          if(this.ECFOP) {
                var cals = await API.sqlprep(this, "registro.selcalnostage", [
                    this.progsel.progettoid,
                    this.loctimeSQL
                ]);
          } else {
            var cals = await API.sqlprep(this, "registro.selcal", [
                    this.progsel.progettoid,
                    this.loctimeSQL
                ]);
          }
          console.log("CALS", cals.data.dati)
          // lo setto qui perché più avanti mi serve per il calcolo della prima ora
          this.cals = cals.data.dati

          // elenco alunni (attenzione: simile nel ChangeCalendar)
          var als
          if (window.MODULIJOIN) {
              als = await API.sqlprep(this, "registro.selalsjoin", [
                  this.progsel.progettoid,
                  this.loctimeSQL,
                  this.progsel.progettoid,
                  this.loctimeSQL,
                  this.loctimeSQL,
                  this.progsel.progettoid
              ]);
          } else {
              als = await API.sqlprep(this, "registro.selals", [
                  this.loctimeSQL,
                  this.progsel.progettoid,
              ]);
          }
          var als2
          if (!window.ENAC) {
              if (window.MODULIJOIN) {
                  als2 = await API.sqlprep(this, "registro.selalsapprjoin", [
                      this.progsel.progettoid,
                      this.loctimeSQL,
                      this.progsel.progettoid,
                      this.loctimeSQL,
                      this.progsel.progettoid,
                      this.loctimeSQL
                  ]);
              } else {
                  als2 = await API.sqlprep(this, "registro.selalsappr", [
                      this.progsel.progettoid,
                      this.progsel.progettoid,
                      this.loctimeSQL,
                  ]);
              }
          }
          var alunni = als.data.dati
              .map(m => ({
                  alunnoid: m.alunnoid,
                  corsistaid: m.corsistaid,
                  ingresso: m.ingresso ? m.ingresso.substr(11, 8) : '',
                  nome: m.nome,
                  cognome: m.cognome,
                  progettoid: m.progettoid, // serve nel caso di moduli condivisi
                  posizione: m.posizione || 0
              }))
              .sort((a, b) => {
                  return a.posizione - b.posizione;
              });
          var alunni2 = window.ENAC ? [] : als2.data.dati
              .map(m => ({
                  alunnoid: m.alunnoid,
                  corsistaid: m.corsistaid,
                  ingresso: m.ingresso,
                  nome: m.nome,
                  cognome: m.cognome,
                  progettoid: m.progettoid, // serve nel caso di moduli condivisi
                  posizione: "APPR"
              }))
              .sort((a, b) => {
                  if (a.cognome < b.cognome) return -1;
                  else if (a.cognome > b.cognome) return 1;
                  else return 0;
              });
          if (alunni2.length > 0) {
              // ci sono apprendisti
              var ams = await API.sqlprep(this, "registro.selapprcols", []);
              moduli = moduli.concat(
                  ams.data.dati
                      .map(m => ({
                          moduloid: m.colonna,
                          nome: m.descr,
                          codice: "",
                          area: ""
                      }))
                      .sort((a, b) => a.colonna - b.colonna)
              );
          }
          alunni = alunni.concat(alunni2);

		  for(let t of alunni)
			if(!this.giustifichedett[t.alunnoid])
				this.giustifichedett[t.alunnoid] = { entra:1, ora: 9}

          // presenze della giornata (per presenze assenze)
          var dpres
          if (window.MODULIJOIN) {
              dpres = await API.sqlprep(this, "registro.selpresjoin", [
                  this.progsel.progettoid,
                  this.loctimeSQL,
                  this.progsel.progettoid,
                  this.loctimeSQL,
                  this.loctimeSQL
              ]);
          } else {
              if(this.ECFOP) {
                dpres = await API.sqlprep(this, "registro.selpresnostage", [
                    this.loctimeSQL,
                    this.progsel.progettoid
                ]);
                let presappr = await API.sqlprep(this, "registro.selpresappr", [
                    this.progsel.progettoid,
                    this.progsel.progettoid,
                    this.progsel.progettoid,
                    this.loctimeSQL
                ]);
                dpres.data.dati = dpres.data.dati.concat(presappr.data.dati)
              } else {
                dpres = await API.sqlprep(this, "registro.selpres", [
                    this.loctimeSQL,
                    this.progsel.progettoid
                ]);
              }
          }
          console.log("PRESENZE:", dpres.data, alunni)
          let pres = {}
          let pPrev = null;
          for (let p of dpres.data.dati) {
              if (!pres["c" + p.corsistaid])
                  pres["c" + p.corsistaid] = {}

              // se sono alla prima ora e non ho il dato, precompilo in base alla presenza dell'ora di ingresso (BADGE)
              // se non sono alla prima ora e non ho il dato, precompilo in base alla presenza dell'ora precedente
              if (p.ora == this.oracorrente && !p.calendarioid) {
                  if (this.primaora) {
                      try { // qualcuno potrebbe non esserci perché ritirato
                          p.presenteoraintera = alunni.find(a => a.corsistaid == p.corsistaid).ingresso ? true : null
                      } catch (error) {
                          p.presenteoraintera = false
                      }
                      p.giustificato = false
                  } else {
                      // grazie all'ordinamento richiesto, l'ora precedente è quella del record prima
                      p.presenteoraintera = pPrev.presenteoraintera
                      p.giustificato = pPrev.giustificato
                  }
              }
              pres["c" + p.corsistaid][p.ora] = p
              pPrev = p;
          }

          // descrizioni voti
          var modids = moduli.map(m => m.moduloid).join();
          if (window.ENAC) {
              // devo aggiungere gli id alternativi relativi all'eventuale progetto abbinato. Per farlo prendo tutti i progetti collegati e mappo
              let progetti = {}
              alunni.forEach(a => {
                  if (this.progsel.progettoid != a.progettoid)
                      progetti[a.progettoid] = true
              })
              var moremodids = []
              for (let m of modids.split(",")) {
                  // console.log("???",progetti,Object.keys(progetti))
                  for (let pid of Object.keys(progetti)) {
                      var tm2 = await API.sqlprep(this, "registroc.getmodcompidbyp", [pid, m]);
                      let m2 = tm2.data.dati[0].getmodcompidbyp
                      this.modcomp[m2] = m
                      if (m2 && m2 != m && !moremodids.includes(m2))
                          moremodids.push(m2)
                  }
              }
              if (moremodids.length)
                  modids = modids + "," + moremodids.join()
          }
          var dess = await API.sqlprep(this, window.ENAC ? "registroc.votidescr" : "registro.votidescr", [], {
              "@modids": modids
          });
          var vdes = [];
          var vdeshm = [];
          dess.data.dati.map(r => r.moduloid = r.moduloid || r.modulocompid)// ENAC
          // devo accorpare le descrizioni provenienti da un possibile modulo abbinato
          dess.data.dati.map(d => {
              let mid = this.modcomp[d.moduloid] || d.moduloid
              if (d.hm) {
                  if (!vdeshm[mid + "_" + d.data])
                      vdeshm[mid + "_" + d.data] = {}
                  vdeshm[mid + "_" + d.data] = { ...vdeshm[mid + "_" + d.data], ...JSON.parse(d.descrizione) };
              } else {
                  if (!vdes[mid + "_" + d.data])
                      vdes[mid + "_" + d.data] = {}
                  vdes[mid + "_" + d.data] = { ...vdes[mid + "_" + d.data], ...JSON.parse(d.descrizione) };
              }
          });
          this.vdescr = vdes;
          this.vhmdescr = vdeshm;
          //console.log("MSGS:",vdes,tmphm)

          // voti e azzeramento note
          var voti = {};
          var aseen = {};
          alunni.forEach(a => {
              aseen["A" + a.alunnoid] = true;
              voti["A" + a.alunnoid] = {};
              let aid = a.alunnoid;
              moduli.forEach(m => {
                  voti["A" + a.alunnoid]["M" + m.moduloid] = [];
                  let mid = m.moduloid;
                  this.barcache[aid + "_" + mid + "_1"] = false;
                  this.barcache[aid + "_" + mid + "_2"] = false;
                  this.barcache[aid + "_" + mid + "_1O"] = false;
                  this.barcache[aid + "_" + mid + "_2O"] = false;
              });
              this.barcache[aid + "_0_1"] = false;
              this.barcache[aid + "_0_2"] = false;
              this.barcache[aid + "_0_1O"] = false;
              this.barcache[aid + "_0_2O"] = false;
          });
          var alids = alunni.map(a => a.alunnoid).join();
          var pgs, pgshm
          if (window.ENAC) {
              pgs = await API.sqlprep(this, "registroc.selpagella", [this.progsel.progettoid], {
                  "@alids": alids,
                  "@num": "0",
                  "@hm": ""
              });
              pgshm = await API.sqlprep(this, "registroc.selpagella", [this.progsel.progettoid], {
                  "@alids": alids,
                  "@num": "1",
                  "@hm": "hm"
              });
              pgs.data.dati.forEach(v => {
                  v.modulocompid = v.convmodcompid
                  delete v.convmodcompid
              })
              pgshm.data.dati.forEach(v => {
                  v.modulocompid = v.convmodcompid
                  delete v.convmodcompid
              })
          } else {
              pgs = await API.sqlprep(this, "registro.selpagella", [], {
                  "@alids": alids,
                  "@num": "0",
                  "@hm": ""
              });
              pgshm = await API.sqlprep(this, "registro.selpagella", [], {
                  "@alids": alids,
                  "@num": "1",
                  "@hm": "hm"
              });
          }
          var pgsa = await API.sqlprep(this, "registro.selpagella_a", [], {
              "@alids": alids
          });

          var pws = await API.sqlprep(this, window.ENAC ? "registroc.selpagellapf" : "registro.selpagellapf", [], {
              alids: alids
          });
          pgs.data.dati = pgs.data.dati.concat(
              pgshm.data.dati,
              pgsa.data.dati,
              pws.data.dati
          );
          pgs.data.dati
              .sort((a, b) => {
                  if (a.data < b.data) return -1;
                  else if (a.data > b.data) return 1;
                  else return 0;
              })
              .map(p => {
                  if(p.moduloid!==0)
                    p.moduloid = p.moduloid || p.modulocompid // ENAC
                  p.nome = this.docs[p.docenteid];
                  var jd = p.hm
                      ? vdeshm[p.moduloid + "_" + p.data]
                      : vdes[p.moduloid + "_" + p.data];
                  if (!jd) {
                      p.descr = "";
                      p.defdescr = "";
                  } else {
                      p.descr = jd["a" + p.alunnoid] ? jd["a" + p.alunnoid] : jd.default;
                      p.defdescr = jd.default;
                  }
                  try {
                      if (voti["A" + p.alunnoid]["M" + p.moduloid])
                          voti["A" + p.alunnoid]["M" + p.moduloid].push(p);
                  } catch (error) {
                      // dati sporchi ?
                      console.error(error);
                  }
              });
          // console.log("pgs.data.dati",pgs.data.dati.map(d => ({
          //     alunnoid: d.alunnoid,
          //     data: d.data,
          //     descr: d.descr,
          //     moduloid: d.moduloid,
          //     nome: d.nome,
          //     voto: d.voto,
          // })))
          // console.log("pgs.data.dati2",pgs.data.dati[0])
          // console.log("pgs.data.dati3",JSON.stringify(pgs.data.dati[0],null,2))
          // console.log("vdes",vdes)
          alunni.forEach(a => {
              moduli.forEach(m => {
                  // aggiungo il pwork solo se non c'è già
                  var empty = voti["A" + a.alunnoid]["M" + m.moduloid].length == 0;
                  if (m.moduloid >= 0 || empty) {
                      voti["A" + a.alunnoid]["M" + m.moduloid].push({
                          alunnoid: a.alunnoid,
                          moduloid: m.moduloid,
                          docenteid: 0
                      });
                  }
                  // inizializzo la fad
                  if (this.modfad) {
                      for (const f of this.fad) {
                          voti['A' + a.alunnoid]['M' + m.moduloid][f.indicatore] = '***'
                      }
                  }
              });
          });

          // aggiungo i voti FAD   voti['A'+alunno.alunnoid]['M'+modulo.moduloid][ind]
          if (this.modfad) {
              for (const fs of this.fadscores) {
                  let aid = fs.alunnoid
                  let modid = 999999
                  let ind = fs.indicatore
                  let v = this.fad.filter(f => f.indicatore == ind && f.score == fs.score)[0].testo
                  voti['A' + aid]['M' + modid][ind] = v
              }
          }

          // console.log("VOTI:", voti);

          // medie
          var medie = {};
          alunni.forEach(a => {
              medie["A" + a.alunnoid] = {};
          });
          var avgs = await API.sqlprep(this, "registro.pagellamedie", [], {
              "@alids": alids
          });
          avgs.data.dati.map(r => r.moduloid = r.moduloid || r.modulocompid)// ENAC
          avgs.data.dati.map(avg => {
              avg.moduloid = avg.moduloid || avg.modulocompid // ENAC
              avg.nome = this.docs[avg.docenteid];
              if (avg.finale)
                  medie["A" + avg.alunnoid]["M" + avg.moduloid + "_2"] = avg;
              else medie["A" + avg.alunnoid]["M" + avg.moduloid + "_1"] = avg;
          });

          // recupero chi ha l'incarico più massiccio su ogni modulo
          if (!ENAC) {
              var docs = await API.sqlprep(this, "registro.docincs", [
                  window.ORE_THRESHOLD,
                  window.ORE_THRESHOLD,
                  this.progsel.progettoid
              ]);
              docs.data.dati.map(d => {
                  moduli.find(m => m.moduloid == d.moduloid).doc = d.nome;
                  moduli.find(m => m.moduloid == d.moduloid).docids = d.docids;
              });
          }
          // vedo se ha visto le note di classe o personali
          var cnote = await API.sqlprep(this, "registro.getCnote", [
              this.progsel.progettoid
          ]);
          var anote = await API.sqlprep(this, "registro.getAnote", [], {
              "@alids": alids
          });
          var cseen = true;
          cnote.data.dati.map(d => {
              if (d.visto) {
                  var visto = JSON.parse(d.visto.replace("{", "[").replace("}", "]"));
                  console.log("VISTO:", d.visto, visto);
                  if (visto.indexOf(me.getUserID()) < 0) cseen = false;
              } else {
                  cseen = false;
              }
              console.log("CNOTE:", d);
          });
          anote.data.dati.map(d => {
              // console.log("ANOTE:", d);
              if (d.visto) {
                  var visto = JSON.parse(d.visto.replace("{", "[").replace("}", "]"));
                  if (visto.indexOf(me.getUserID()) < 0)
                      aseen["A" + d.alunnoid] = false;
              } else {
                  aseen["A" + d.alunnoid] = false;
              }
          });
          this.pres = pres
          this.anote = anote.data.dati;
          this.cnote = cnote.data.dati;
          this.cseen = cseen;
          this.aseen = aseen;
          this.voti = voti;
          this.medie = medie;
          this.moduli = moduli;
          this.alunni = alunni;
          this.loading = false;
          this.forceUpdate++; // per forzare alcuni aggiornamenti. 
          console.log("PRESENZE1", this.pres)

          console.log("VOTI", this.voti)
      }
    },
    created: async function () {
        var url = new URL(window.location.href);
        var progettoid = url.searchParams.get("progettoid");

        var token = this.getTokenData().sub;
        var prgs;

        let tsedi = await API.sqlprep(this, "registro.selsedi", []);
        console.log("SEDI:", tsedi)
        let sedi = []
        for (let sede of tsedi.data.dati) {
            sedi[sede.sedeid] = sede.nome
        }

        if (progettoid) // dal SW potrebbe arrivare la richiesta per un progetto di una sede diversa
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else if (this.getUserLIV() < 3)
            prgs = await API.sqlprep(this, "registro.selproginc", [token.user.docenteid, token.user.docenteid]);
        else if (this.getUserLIV() >= 5)
            prgs = await API.sqlprep(this, "registro.selprog", []);
        else
            prgs = await API.sqlprep(this, "registro.selprogsede", [token.user.sedeid]);

        this.progetti = prgs.data.dati
            .map(p => ({
                progettoid: p.progettoid,
                annualita: p.annualita,
                sedeid: p.sedeid,
                nome: sedi[p.sedeid] + ": " + p.numero + " - " + p.nome,
                noss: p.nosoftskills || NOSOFTSKILLS,
                nomr: p.nomodrel,
                nouf: p.nouf || window.GREEN,
                scrutinio1: p.scrutinio1,
                scrutinio2: p.scrutinio2,
            }))
            .sort((a, b) => {
                if (a.nome < b.nome) return -1;
                else if (a.nome > b.nome) return 1;
                else return 0;
            });

        var dtmp = await API.sqlprep(this, "registro.seldocs", []);
        var docs = [];
        dtmp.data.dati.map(d => {
            docs[d.docenteid] = d.nome;
        });
        this.docs = docs;

        if (progettoid) {
            this.progsel = this.progetti.find(p => p.progettoid == progettoid);
            this.noprogsel = true;
            this.fprogsel();
        }
        if (window.MODULIJOIN) {
            dtmp = await API.sqlprep(this, "registro.modulijoin", []);
            for (let t of dtmp.data.dati)
                this.modulijoin['' + t.m1] = t.m2
            console.log("modulijoin", this.modulijoin)
        }
    }
};
</script>
<style scoped>
span.presenteNO {
    background-color: red;
}
span.presenteSI {
    background-color: green;
}
span.presenteNI {
    background-color: yellow;
}
span.giustificaSI {
    background-color: ORANGE;
}
textarea.argomento {
  width: 100%;
}
.blink {
  animation: blink 0.5s linear infinite;
}
@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.datavoto {
  width: 110px;
  display: inline-block;
  border-style: ridge;
}
.voto {
  width: 30px;
  text-align: right;
  background-color: lightgreen;
  display: inline-block;
  border-style: ridge;
}
.fa-paperclip {
  color: blue;
}
.fa-trash {
  color: red;
}
th.rot90 {
  /* height: 200px;
  transform: rotate(-90deg) translateY(20px);
  transform-origin: left bottom 0; */
  min-width: 210px;
}
th.rot90 span {
  font-weight: normal;
}
table.registro td {
  vertical-align: top;
  border: 1px solid black;
}
table.registro th {
  vertical-align: bottom;
}
div.scroll {
  overflow: scroll;
}
.votohm {
  position: relative;
  left: -73px;
  width: 0px;
}
.votohmc {
  position: relative;
  left: -20px;
  width: 0px;
}
.w100 {
  width: 100%;
}
td.nowrap {
  white-space: nowrap;
  position: relative;
  vertical-align: top;
}
div.premedie {
  height: 100px;
}
div.premedie button {
  position: absolute;
  bottom: 90px;
  z-index: 99;
}
div.premedie2 {
  height: 30px;
}
div.premedie2 button {
  position: absolute;
  bottom: 20px;
  z-index: 99;
}
div.medie {
  position: absolute;
  bottom: 6px;
}
.clickme {
  cursor: pointer;
}
</style>
<style>
body.wait  * {
  cursor: wait;
}
td.nowrap .vdatetime-popup {
  white-space: initial !important;
}
div.registro input.vdatetime-input {
  width: 100%;
}
div.mediaforced {
  background-color: lightskyblue;
}
table.prospettomoduli {
  width: 100%;
  table-layout: fixed;
}
table.prospettomoduli th {
  text-align: center;
}
table.prospettomoduli button {
  width: 100%;
}
span.liv7 {
  cursor: pointer;
}
span.saving {
	background-color: orange;
}
span.saved {
	background-color: lightgreen;
}
</style>